import Grid from '@blocks/Grid'
import Table from '@modules/Table'
import { Box, Container } from '@styles/helpers'
import useSalonController from '@general/api/useSalonController'
import useSalon from '@general/models/Salon'
import useTitle from '@hooks/useTitle'
import { tablet } from '@styles/mixins'
import { grid } from '@styles/vars'
import React from 'react'
import { useParams } from 'react-router'
import { Column } from 'react-table'
import styled, { css } from 'styled-components'
import Button from '@blocks/Button'
import { route } from '@shared/helpers'

export default function SalonAcceptancesPage() {
    const { slug } = useParams<{ slug: string }>()
    const salon = useSalon(slug)

    const controller = useSalonController()
    const acceptances = controller.acceptances(slug).use()

    const name = salon.state?.name || "Loading..."
    useTitle(`Acceptances List: ${name}`)

    if (!salon.state) 
        return null

    if (!acceptances.data) 
        return null

    return (
        <AcceptancesContainer>
            <Grid>
                <Grid gap="20px">
                    <Grid gap="10px">
                        <h1>Acceptances List</h1>
                        <h2 className="h3">{salon.state.name}</h2>
                    </Grid>
                    <Button type="secondary" width="fixed" to={route("general:salon:acceptances:gallery", salon.state.slug, null)}>See Gallery</Button>
                </Grid>
                <Box narrow>
                    <Table data={acceptances.data} columns={columns} />
                </Box>
            </Grid>
        </AcceptancesContainer>
    )
}

const columns: Column<Resources.Acceptance>[] = [
    {
        Header: 'First Name',
        accessor: 'first_name'
    },
    {
        Header: 'Last Name',
        accessor: 'last_name'
    },
    {
        Header: 'Country',
        accessor: 'country'
    },
    {
        Header: 'Section',
        accessor: 'section'
    },
    {
        Header: 'Title',
        accessor: 'title'
    }
]

const AcceptancesContainer = styled(Container)`
    padding-top: ${grid.margins.phone};
    padding-bottom: ${grid.margins.phone};

    ${tablet(css`
        padding-top: ${grid.margins.tablet};
        padding-bottom: ${grid.margins.tablet};
    `)}
`